import { Chatv1Error } from '../chatv1/transport'

/**
 * A DM THAT WILL NOT OPEN HAS TO SAY SO.
 *
 * Owner, 2026-09-16: 我好友那邊無法進入 friend chat — and 「無法進入」, not an error
 * code, is the exact shape of this defect. The server answered his friend with a
 * specific, diagnosable `404 unknown_peer` on every attempt; `useManagedFriendDm`
 * returned it as `error`, its own docstring said the caller should show it, and
 * nothing read it. So the panel was simply empty: no message, no retry, no way to
 * tell "you two are not friends any more" from "the server is having a bad
 * minute". Tapping again did nothing visible, which reads as the app being broken
 * for you alone — and it is why finding the cause took a database query instead
 * of a screenshot.
 *
 * The codes are kept APART rather than folded into one apology, because the
 * person can act on the difference: one of them is fixed by adding the friend
 * back, one by waiting, and one by signing in again. A single "something went
 * wrong" would have been the same blank screen with extra steps.
 *
 * Deliberately says nothing about accounts being deleted. `unknown_peer` means
 * this service cannot resolve that address right now; which of several reasons
 * caused it is not something the client can know, and guessing out loud would
 * announce someone else's account deletion to their friend.
 */
export function dmOpenMessage(err: unknown): string {
  const code = err instanceof Chatv1Error ? err.code : ''
  switch (code) {
    case 'unknown_peer':
      return "We can't reach that account right now, so this chat could not be opened. Try again shortly."
    case 'not_friends':
      return 'You are not friends with this person any more, so this chat is closed.'
    case 'friend_gate_unavailable':
      return 'Chat is temporarily unavailable. Please try again shortly.'
    case 'no_token':
    case 'unauthorized':
      return 'Your session has expired. Sign in again to open this chat.'
    default:
      return 'This chat could not be opened. Please try again shortly.'
  }
}
